import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setCompany } from "../../redux/companySlice";
import { setUser } from "../../redux/userSlice";
import { TextBox } from "devextreme-react";
import Modal from "react-modal";
import { RadioGroup, List } from 'devextreme-react';
import { UserCompanyService } from "../../apis/apiServices/userCompany";
import secureLocalStorage from "react-secure-storage";
import { Loader } from "./PageLoader";

export default function ChangeCompanyComponent() {
    const dispatch = useDispatch();
    const reduxCompany = useSelector((state) => state.company?.data);
    const user = useSelector((state) => state.user?.data);

    const [isLoading, setIsLoading] = useState(false);
    const [companyList, setCompanyList] = useState([]);
    const [selectedCompanyItems, setSelectedCompanyItems] = useState(null);
    const [selectedCompanyId, setSelectedCompanyId] = useState(reduxCompany?.id);

    const fetchUserWiseCompanies = async () => {
        let response = await UserCompanyService?.getUserWiseAssignedCompanies(user?.userId);

        setCompanyList((response?.isSuccess) ? response?.data || [] : []);
    }

    const closeModal = () => {
        dispatch(
            setCompany({
                ...reduxCompany,
                id: reduxCompany?.id || 1,
                isChangeCompanyModalOpen: false,
            })
        );
    }

    useEffect(() => {
        fetchUserWiseCompanies();
    }, []);

    const submitHandler = async () => {

        const companyPayload = {
            ...reduxCompany,
            ...selectedCompanyItems,
            isChangeCompanyModalOpen: !reduxCompany?.isChangeCompanyModalOpen,
        }

        const userPayload = {
            ...user,
            userDepartmentId: companyPayload?.userDepartmentId,
            userDepartmentName: companyPayload?.userDepartmentName,
            userDesignationId: companyPayload?.userDesignationId,
            userDesignationName: companyPayload?.userDesignationName,
            levelId: companyPayload?.levelId,
        }

        secureLocalStorage.setItem("company", companyPayload)
        secureLocalStorage.setItem("user", userPayload);
        dispatch(
            setCompany(
                
                companyPayload)
        );
        dispatch(setUser(userPayload));

        setTimeout(() => {
            window.location.reload();
        }, 1);

    }

    return (
        <>
            <Modal
                ariaHideApp={false}
                isOpen={reduxCompany?.isChangeCompanyModalOpen}
                className="react-modal custom-modal-medium change-company-modal"
                onRequestClose={closeModal}
                shouldCloseOnOverlayClick={false}
                contentLabel="State Modal"
            >
                {/* <form>
                    <div className="modal-header">
                        <h6 className="modal-title">Switch Company</h6>
                    </div>

                    <div className="modal-body">
                        <div className='form-group'>
                            <label>Company <span className="text-danger">*</span></label>
                            <List
                                dataSource={companyList || []}
                                keyExpr="id"
                                selectionMode="single" // multiple 
                                showSelectionControls={true}
                                selectedItemKeys={[reduxCompany?.id]}
                                onSelectionChanged={(e) => {
                                    let selectedItem = e?.component?.option("selectedItem");
                                    const companyPayload = {
                                        ...selectedItem,
                                        isChangeCompanyModalOpen: !reduxCompany?.isChangeCompanyModalOpen,
                                    }
                                    const userPayload = {
                                        ...user,
                                        userDepartmentId: companyPayload?.userDepartmentId,
                                        userDepartmentName: companyPayload?.userDepartmentName,
                                        userDesignationId: companyPayload?.userDesignationId,
                                        userDesignationName: companyPayload?.userDesignationName,
                                        levelId: companyPayload?.levelId,
                                    }
                                    secureLocalStorage.setItem("company", companyPayload)
                                    secureLocalStorage.setItem("user", userPayload);
                                    dispatch(
                                        setCompany(companyPayload)
                                    );
                                    dispatch(setUser(userPayload));
                                    setTimeout(() => {
                                        window.location.reload();
                                    }, 1);
                                }}
                                itemRender={(comp) => (
                                    <div>{comp?.companyName} ({comp?.companyCode})</div>
                                )}
                            />
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-outline-primary btn-sm"
                            onClick={closeModal}
                            title="Cancel"
                        >
                            <i className="fas fa-times"></i> Cancel
                        </button>

                    </div>


                </form> */}

                <form>
                    <div className="modal-header">
                        <h6 className="modal-title">Select company and continue</h6>
                    </div>
                    <div className="modal-body">

                        {companyList.map((comp) => {
                            return (
                                <label class="custom-radio" key={comp?.id} >
                                    <input type="radio" name="radio"
                                        value={comp.id}
                                        checked={selectedCompanyId === comp.id}
                                        onChange={() => {
                                            setSelectedCompanyItems(comp);
                                            setSelectedCompanyId(comp.id)
                                        }}
                                    />
                                    <span class="radio-btn"
                                    ><i class="las la-check"></i>
                                        <div className="logo-company">
                                            <img
                                               // src={`./assets/img/Company/${comp?.id}/company-logo.png`}
                                                 src={`${process.env.REACT_APP_CDN_VISHWAM_BASE_URL + comp?.companyLogoPath}`}
                                                alt=""
                                                className="brand-image"
                                                height="35px"
                                                onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.src = "./assets/img/Company/1/default-company-logo.png"; // fallback
                                                }}
                                            />
                                            {/* <i class="las la-biking"></i> */}
                                        </div>
                                        <div className="info-company">
                                            <div className="name">{comp.companyName} </div>
                                            <div className="code">({comp.companyCode})</div>
                                        </div>
                                    </span>
                                </label>

                            )
                        })}
                    </div>


                    <div className="modal-footer text-center">
                        <button
                            type="button"
                            className="btn btn-outline-primary btn-sm"
                            onClick={closeModal}
                            title="Cancel"
                        >
                            <i className="fas fa-times"></i> Cancel
                        </button>

                        <button
                            type="button"
                            className="btn btn-outline-primary btn-sm "
                            onClick={submitHandler}
                            title="Proceed"
                        >
                            <i className="fas fa-check"></i> Continue
                        </button>

                    </div>

                    {isLoading && <Loader loadingMessage={""} />}
                </form>
            </Modal>
            {isLoading && <Loader loadingMessage={""} />}
        </>
    );
}